module.exports = __webpack_public_path__ + "img/14-full-sm.af86bdd1.jpg";